import React, { useLayoutEffect, useRef, useState } from 'react';

interface ScrollingProjectNameProps {
  name: string;
  className?: string;
}

export function ScrollingProjectName({ name, className = '' }: ScrollingProjectNameProps) {
  const wrapRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);
  const [overflowing, setOverflowing] = useState(false);
  const [shift, setShift] = useState(0);

  useLayoutEffect(() => {
    const measure = () => {
      const wrap = wrapRef.current;
      const text = textRef.current;
      if (!wrap || !text) return;
      const overflow = Math.max(0, text.scrollWidth - wrap.clientWidth);
      setOverflowing(overflow > 1);
      setShift(overflow);
    };

    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [name]);

  return (
    <div
      ref={wrapRef}
      className={`scrolling-project-name${className ? ` ${className}` : ''}${overflowing ? ' is-overflowing' : ''}`}
      style={{ '--scrolling-project-name-shift': `${shift}px` } as React.CSSProperties}
      title={name}
    >
      <span ref={textRef} className="scrolling-project-name-text">{name}</span>
    </div>
  );
}
